import { ErrorBoundary } from '@genial/components';
import React from 'react';

export const InvestmentStrategyNotFound: React.FC = () => {
  return (
    <ErrorBoundary
      errorIconOrIllustration="NotFoundIllustration"
      errorMessage="Não há resultados correspondentes a este período de 30 dias"
      errorTitle="Nenhum resultado corresponde à sua pesquisa"
    />
  );
};
